"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentUnscopeUserReducerBase = void 0;
var tslib_1 = require("tslib");
var actions_1 = require("../../constants/actions");
var isFirestoreTimestamp_1 = require("../../sdks/firebase/isFirestoreTimestamp");
var currentUnscopeUserReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === actions_1.GET_UNSCOPE_USER_SUCCESS) {
        return tslib_1.__assign({}, action.successValues.item);
    }
    if (action.type === actions_1.PATCH_UNSCOPE_USER_REQUEST) {
        var _a = action.requestValues.item, created = _a.created, wentWrongErrorCount = _a.wentWrongErrorCount, theRest = tslib_1.__rest(_a, ["created", "wentWrongErrorCount"]);
        var valueMutable = tslib_1.__assign({}, theRest);
        // because created might be a FiedValue
        if ((0, isFirestoreTimestamp_1.isFirestoreTimestamp)(created)) {
            valueMutable.created = created;
        }
        return tslib_1.__assign(tslib_1.__assign({}, state), theRest);
    }
    if (action.type === actions_1.POST_UNSCOPE_USER_REQUEST) {
        return tslib_1.__assign({}, action.requestValues.item);
    }
    if (action.type === 'SIGN_OUT_SUCCESS') {
        return null;
    }
    return state || null;
};
exports.currentUnscopeUserReducerBase = currentUnscopeUserReducerBase;
